import { render, staticRenderFns } from "./working-in-groups-a45.vue?vue&type=template&id=78ed484d&"
import script from "./working-in-groups-a45.vue?vue&type=script&lang=js&"
export * from "./working-in-groups-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports